import { MonoBehavior } from 'game/core/monoBehavior';
import { Container, Point } from 'pixi.js';
import { DesignSection, DesignTabs } from './DesignSection';
import { DesignTopBar } from './DesignTopBar';
import { addToUI } from 'game/core/Playable2DRootContainer';
import { getScreenSize } from 'game/core/screen';
import { DESKTOP_UI_WIDTH, Displays } from 'constants/layout';
import { Layout } from 'game/LayoutManager';
import { Title } from './Title';
import CloseDesign from './CloseDesign';
import gsap, { Power1 } from 'gsap';

export class GameDesigns extends MonoBehavior {
    hideOptions: () => void;
    container: Container;
    bgTab: DesignSection;
    backTab: DesignSection;
    frontTab: DesignSection;
    designTopBar: DesignTopBar;
    designTitle: Title;
    closeDesignButton: CloseDesign;

    constructor(hideOptions: () => void) {
        super();
        this.changeTabs = this.changeTabs.bind(this);
        this.hideOptions = hideOptions;
        this.closeDesignButton = new CloseDesign(this.hideOptions);

        this.container = new Container();
        this.container.visible = false;

        this.designTitle = new Title('design');

        this.bgTab = new DesignSection(DesignTabs.BACKGROUNDS);
        this.backTab = new DesignSection(DesignTabs.BACKS);
        this.frontTab = new DesignSection(DesignTabs.FRONTS);
        this.designTopBar = new DesignTopBar(this.changeTabs);

        this.container.addChild(this.bgTab.scrollContainer.container);
        this.container.addChild(this.backTab.scrollContainer.container);
        this.container.addChild(this.frontTab.scrollContainer.container);

        this.container.addChild(this.designTopBar.container);
        this.container.addChild(this.designTitle.container);
        this.container.addChild(this.closeDesignButton.container);
    }
    changeTabs(tab: DesignTabs) {
        this.bgTab.setActive(tab === DesignTabs.BACKGROUNDS);
        this.backTab.setActive(tab === DesignTabs.BACKS);
        this.frontTab.setActive(tab === DesignTabs.FRONTS);
    }

    start(): void {
        addToUI(this.container);
        this.container.position.set(getScreenSize().width + this.container.width * 0.5, 100);
    }

    handleOptions() {
        const device = Layout.getDisplay();
        // move to settings class

        switch (device) {
            case Displays.DESKTOP:
                const designPosition = new Point(0, 93);
                this.bgTab.container.position = designPosition;
                this.backTab.container.position = designPosition;
                this.frontTab.container.position = designPosition;
                this.designTopBar.container.position = designPosition;
                break;

            case Displays.TABLET:
                const designPositionTablet = new Point(0, 93);
                this.bgTab.container.position = designPositionTablet;
                this.backTab.container.position = designPositionTablet;
                this.frontTab.container.position = designPositionTablet;
                this.designTopBar.container.position = designPositionTablet;
                break;
            case Displays.MOBILE:
                //refactor
                const designPositionMobile = new Point(0, 85);
                this.bgTab.container.position = designPositionMobile;
                this.backTab.container.position = designPositionMobile;
                this.frontTab.container.position = designPositionMobile;
                this.designTopBar.container.position = designPositionMobile;

                break;
        }
    }
    hide(easeTime: number) {
        const { width, height } = getScreenSize();
        const display = Layout.getDisplay();

        let targetX = 0;
        switch (display) {
            case Displays.DESKTOP:
                targetX = width + 0.5 * this.container.width;
                break;
            case Displays.TABLET:
                targetX = width + 0.5 * this.container.width;
                break;
            case Displays.MOBILE:
                targetX = width + 0.5 * this.container.width;
                break;
        }
        if (easeTime) {
            gsap.to(this.container.position, {
                x: width + DESKTOP_UI_WIDTH * 0.5,
                y: 0,
                ease: Power1.easeInOut,
                duration: easeTime,
            });
        } else {
            this.container.position.set(targetX, 0);
        }
    }
    show(easeTime: number) {
        const { width } = getScreenSize();
        const display = Layout.getDisplay();
        this.container.visible = true;

        let targetX = 0;
        switch (display) {
            case Displays.DESKTOP:
            case Displays.TABLET:
                targetX = width - DESKTOP_UI_WIDTH * 0.5;
                break;
            case Displays.MOBILE:
                targetX = width * 0.5;
                break;
        }

        if (easeTime) {
            gsap.to(this.container.position, {
                x: targetX,
                y: 0,
                ease: Power1.easeInOut,
                duration: easeTime,
            });
        } else {
            this.container.position.set(targetX, 0);
        }

        this.designTopBar.show();
    }
}
